import React, { createContext, useEffect, useState } from "react";
import { getSortedCollection } from "sprint-common-web";

import { GetMuxSpecificationsLookupResponse } from "../../api/orders-api/mux-specification/responses/GetMuxSpecificationsLookupResponse";
import { useMuxSpecificationApi } from "../../api/orders-api/mux-specification/useMuxSpecificationApi";
import { mapToMuxSpecification, MuxSpecification } from "../../types/MuxSpecification";

interface IMuxSpecificationsDataContext {
    muxSpecifications: MuxSpecification[];
    isLoading: boolean;
}

export const MuxSpecificationsDataContext = createContext<IMuxSpecificationsDataContext>({
    muxSpecifications: [],
    isLoading: true
});

type MuxSpecificationsDataProviderProps = React.PropsWithChildren<unknown>;

export const MuxSpecificationsDataProvider: React.FunctionComponent<MuxSpecificationsDataProviderProps> = ({
    children
}: MuxSpecificationsDataProviderProps) => {
    const [muxSpecifications, setMuxSpecifications] = useState<MuxSpecification[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { getMuxSpecificationsLookup } = useMuxSpecificationApi();

    useEffect(() => {
        setIsLoading(true);

        getMuxSpecificationsLookup()
            .then((response: GetMuxSpecificationsLookupResponse) => {
                const newItems = response.items.map(mapToMuxSpecification);
                const sortedItems = getSortedCollection(newItems, "name");

                setMuxSpecifications(sortedItems);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return (
        <MuxSpecificationsDataContext.Provider value={{ muxSpecifications, isLoading }}>
            {children}
        </MuxSpecificationsDataContext.Provider>
    );
};
